import { jsxs as n, jsx as e } from "react/jsx-runtime";
import { useRef as V, useState as s, useEffect as h } from "react";
import { useBreakpoint as k, Breakpoints as t, Carousel as p } from "@nextgen-web-framework/all";
import _ from "../FeaturedArticle/FeaturedArticle.js";
import w from "../SkeletonLoader/SkeletonLoader.js";
import '../../assets/FeaturedArticleCarousalComponent.css';const B = "#ffffff", b = "#396e75", v = "#e5fdff", G = "#546223", R = "#f0fae5", O = "#a65523", S = "#fff1e8", W = "#7f3e3e", L = "#ffe2e2", y = "#62625a", A = "#f8f8e7", N = "#38539a", Y = "#707070", x = "#c8f8d1", E = "#87c9c8", T = "#5291b1", $ = "rgba(82, 145, 177, 0.1019607843)", j = "#445685", F = "#181d61", M = "rgba(24, 29, 97, 0.1019607843)", P = "#5969d6", X = "#ea999d", D = "#b6577e", I = "rgba(182, 87, 126, 0.1019607843)", q = "#7e3e80", H = "#1e247f", J = "rgba(30, 36, 127, 0.1019607843)", K = "#da7600", Q = "#107f47", U = "#d91734", Z = "_html_18etp_38", r = {
  amwayWhite: B,
  darkBlue: b,
  lightBlue: v,
  darkGreen: G,
  lightGreen: R,
  darkOrange: O,
  lightOrange: S,
  darkRed: W,
  lightRed: L,
  darkYellow: y,
  lightYellow: A,
  darkPurple: N,
  darkGrayOnWhite: Y,
  dataVizColor1: x,
  dataVizColor2: E,
  dataVizColor3: T,
  dataVizColor3Background: $,
  dataVizColor4: j,
  dataVizColor5: F,
  dataVizColor5Background: M,
  dataVizColor6: P,
  dataVizColor7: X,
  dataVizColor8: D,
  dataVizColor8Background: I,
  dataVizColor9: q,
  dataVizColor10: H,
  dataVizColor10Background: J,
  dataVizAlertOrange: K,
  dataVizSuccessGreen: Q,
  dataVizWarningRed: U,
  "no-visible": "_no-visible_18etp_34",
  html: Z,
  "featured-article-container": "_featured-article-container_18etp_72",
  "featured-article-carousal-title": "_featured-article-carousal-title_18etp_72",
  "featured-article-carousal-container": "_featured-article-carousal-container_18etp_81",
  "featured-article-carousel": "_featured-article-carousel_18etp_1",
  "featured-article-carousal-item": "_featured-article-carousal-item_18etp_88"
}, da = (o) => {
  const i = k(), u = [t.SM, t.XS].includes(i), f = [t.LG, t.XL].includes(i), d = V(null), [z, g] = s(0), [l, C] = s(!0);
  return h(() => {
    const a = () => {
      var c;
      const m = ((c = d.current) == null ? void 0 : c.getBoundingClientRect().width) ?? 1116;
      g(m * (f ? 0.82 : 0.92)), C(!1);
    };
    return a(), window.addEventListener("resize", a), () => window.removeEventListener("resize", a);
  }, []), /* @__PURE__ */ n("div", { className: `${r["featured-article-container"]}`, "data-testid": "featured-article-caraousal-container", "data-pod-name": "commerce", children: [
    /* @__PURE__ */ e("h2", { className: r["featured-article-carousal-title"], children: o.featuredArticleCarousalTitle }),
    /* @__PURE__ */ n("div", { className: `${r["featured-article-carousal-container"]}`, children: [
      /* @__PURE__ */ e("div", { ref: d, children: !l && /* @__PURE__ */ e(p, { id: "featured-article-carousel", isTileCarousel: !0, "data-testid": "featured-article-caraousal", "data-pod-name": "commerce", children: o.featuredArticleCarousalItems.map((a) => /* @__PURE__ */ e(
        "div",
        {
          className: `${r["featured-article-carousal-item"]}`,
          style: { width: u ? "100%" : z },
          children: /* @__PURE__ */ e(_, { ...a })
        },
        a.brandTitle
      )) }) }),
      l && /* @__PURE__ */ e(w, { height: 300, borderRadius: 12 })
    ] })
  ] });
};
export {
  da as default
};
//# sourceMappingURL=FeaturedArticleCarousalComponent.js.map
